import React, { useState } from "react";
import { Carousel, Button, Container } from "react-bootstrap";
import { Phone, ArrowRight, ChevronLeft, ChevronRight } from "react-feather";

const CarouselBanner = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const slides = [
    {
      id: 1,
      title: "Expert Legal Representation",
      description: "18+ years of trusted legal expertise",
      bgImage:
        "s1.jpg",
     
    },
    {
      id: 2,
      title: "Comprehensive Legal Solutions",
      description: "Protecting your rights and interests",
      bgImage:
        "s2.jpg",
    
    },
    
  ];

  return (
    <div className="position-relative">
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        interval={5000}
        indicators={false}
        controls={false}
        fade
      >
        {slides.map((slide) => (
          <Carousel.Item key={slide.id}>
            <div
              style={{
                height: "520px",
                backgroundImage: ` url(${slide.bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <Container className="h-100 d-flex flex-column justify-content-center text-center text-white">
                <h1 className="display-4 fw-bold mb-3">
                  {slide.title}
                </h1>
                <p className=" fs-4 mb-4">
                  {slide.description}
                </p>

                <div className="d-flex justify-content-center gap-3 flex-wrap d-none">
                  <Button
                    size="lg"
                    className="fw-bold px-4 py-3 rounded-pill d-flex align-items-center"
                    style={{
                      background: "var(--rna-secondary)",
                      border: "none",
                      color: "var(--rna-dark)",
                    }}
                  >
                    Free Consultation
                    <ArrowRight size={20} className="ms-2" />
                  </Button>

                  <Button
                    size="lg"
                    className="fw-bold px-4 py-3 rounded-pill d-flex align-items-center"
                    style={{
                      background: "transparent",
                      border: "2px solid white",
                      color: "white",
                    }}
                  >
                    <Phone size={20} className="me-2" />
                    +91 94734 25998
                  </Button>
                </div>
              </Container>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Left Arrow */}
      <button
        onClick={() =>
          setIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1))
        }
        className="position-absolute top-50 start-0 translate-middle-y ms-3"
        style={{
          zIndex: 5,
          background: "var(--rna-primary)",
          border: "none",
          color: "white",
          width: "48px",
          height: "48px",
          borderRadius: "50%",
        }}
      >
        <ChevronLeft />
      </button>

      {/* Right Arrow */}
      <button
        onClick={() =>
          setIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1))
        }
        className="position-absolute top-50 end-0 translate-middle-y me-3"
        style={{
          zIndex: 5,
          background: "var(--rna-primary)",
          border: "none",
          color: "white",
          width: "48px",
          height: "48px",
          borderRadius: "50%",
        }}
      >
        <ChevronRight />
      </button>

      {/* Indicators */}
      <div className="position-absolute bottom-0 start-50 translate-middle-x mb-4">
        <div className="d-flex gap-2">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              style={{
                width: index === i ? "12px" : "8px",
                height: index === i ? "12px" : "8px",
                borderRadius: "50%",
                border: "none",
                background:
                  index === i
                    ? "var(--rna-secondary)"
                    : "rgba(255,255,255,0.5)",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CarouselBanner;
